// skipcq: JS-W1028
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const QUEUE_NAV_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

function BeerDuplicateReviewQueueNav({
  showQueueNav,
  previousDisabled,
  nextDisabled,
  positionLabel,
  onPrevious,
  onNext,
}) {
  if (!showQueueNav) {
    return null;
  }

  return (
    <Box sx={QUEUE_NAV_SX}>
      <Button
        startIcon={<ArrowBackIosIcon />}
        onClick={onPrevious}
        disabled={previousDisabled}
      >
        Previous
      </Button>
      {positionLabel ? (
        <Typography variant="body2" color="text.secondary">
          {positionLabel}
        </Typography>
      ) : null}
      <Button
        endIcon={<ArrowForwardIcon />}
        onClick={onNext}
        disabled={nextDisabled}
      >
        Next
      </Button>
    </Box>
  );
}

BeerDuplicateReviewQueueNav.propTypes = {
  showQueueNav: PropTypes.bool,
  previousDisabled: PropTypes.bool,
  nextDisabled: PropTypes.bool,
  positionLabel: PropTypes.string,
  onPrevious: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

BeerDuplicateReviewQueueNav.defaultProps = {
  showQueueNav: false,
  previousDisabled: true,
  nextDisabled: true,
  positionLabel: '',
};

export default BeerDuplicateReviewQueueNav;
